import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refreshUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const hash = window.location.hash;
        const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");

        if (!sessionId) {
          navigate("/login", { replace: true });
          return;
        }

        // Get claim_code from localStorage if set before Google redirect
        const pendingClaimCode = localStorage.getItem("anon_pending_claim_code");
        localStorage.removeItem("anon_pending_claim_code");

        const payload = { session_id: sessionId };
        if (pendingClaimCode) {
          payload.claim_code = pendingClaimCode;
        }

        const { data } = await api.post("/auth/google/session", payload);

        // Clear the hash from URL
        window.history.replaceState(null, "", window.location.pathname);

        await refreshUser();

        if (data.auto_claimed) {
          navigate("/inbox", {
            replace: true,
            state: { justClaimed: true, claimedAlias: data.auto_claimed },
          });
        } else {
          navigate("/inbox", { replace: true });
        }
      } catch (err) {
        console.error("Google auth callback failed:", err);
        navigate("/login", {
          replace: true,
          state: { error: "Google authentication failed. Please try again." },
        });
      }
    };

    processSession();
  }, [navigate, refreshUser]);

  return (
    <div className="h-screen flex items-center justify-center bg-white" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-3">
        <div className="w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-zinc-500">Signing in with Google...</p>
      </div>
    </div>
  );
}
